module.exports = __webpack_public_path__ + "img/prioritas_bosspack_k.0bac480f.png";